import { render, staticRenderFns } from "./statementDetail.vue?vue&type=template&id=667a9826&"
import script from "./statementDetail.vue?vue&type=script&lang=ts&"
export * from "./statementDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports